import * as types from '../mutation-types'
import { restApiRequest, getErrorMessage } from './ajax'

const report = {
  namespaced: true,
  state: {
    report: {}
  },
  getters: {
    dailyReport: state => (state.report ? state.report.dailyReport : []),
    info: state => (state.report ? state.report.info : {}),
    total: state => (state.report ? state.report.total : {})
  },
  mutations: {
    [types.RECEIVE_SETREPORT](state, report) {
      state.report = report
    }
  },
  actions: {
    /**
     * レポートを取得する
     * @param {*} params
     */
    getReport: function({ commit }, params) {
      return new Promise((resolve, reject) => {
        const baseURL = process.env.BaseURL
        const campaignPeriodId = params.campaignPeriodId
        restApiRequest(baseURL, `/api/cpxreport/list/${params.privateCode}/${campaignPeriodId}`, params.jwtToken)
          .then(result => {
            if (result.status === 200) {
              const report = parse(result)
              commit(types.RECEIVE_SETREPORT, report)
              resolve(report)
            } else {
              reject(new Error('Irregular Error.'))
            }
          })
          .catch(err => {
            if (!err) {
              resolve(undefined)
            } else if (!err.response) {
              reject(new ReferenceError('commons.restapi.system.error'))
              return
            } else if (err.response.data.errorCode === 'permission.expiration.error') {
              reject(new Error(getErrorMessage(err.response.data.errorCode)))
              return
            }
            reject(new ReferenceError(getErrorMessage(err.response.data.errorCode)))
          })
      })
    },
    reset: function({ commit }) {
      commit(types.RECEIVE_SETREPORT, undefined)
    }
  }
}
function parse(response) {
  return response.data
}
export default report
